// extracted by mini-css-extract-plugin
export default {"gridContainer":"Home_gridContainer__KVX5D","grid":"Home_grid__KD8WM"};